export enum ContentStatusEnum {
  DRAFT = "draft",
  PUBLISHED = "published",
  ARCHIVED = "archived",
}

export enum SentimentEnum {
  NEGATIVE = "negative",
  NEUTRAL = "neutral",
  POSITIVE = "positive",
}

export enum ChangeDirectionEnum {
  BUILD = "build",
  BREAK = "break",
}

export enum ScopeEnum {
  GENERIC = "generic",
  BELIEF = "belief",
  STORY = "story",
  HABIT = "habit",
}

export enum PriorityEnum {
  LOW = "low",
  NORMAL = "normal",
  HIGH = "high",
  CRITICAL = "critical",
}

export enum DifficultyEnum {
  EASY = "easy",
  NORMAL = "normal",
  HARD = "hard",
}

export enum TimeHorizonEnum {
  SHORT_TERM = "short_term",
  MEDIUM_TERM = "medium_term",
  LONG_TERM = "long_term",
}

export enum CognitivePatternTypeEnum {
  DISTORTION = "distortion",
  BIAS = "bias",
  SCHEMA = "schema",
}

export enum EmbeddingStatusEnum {
  MISSING = "missing",
  INCOMPLETE = "incomplete",
  PENDING = "pending",
  PROCESSING = "processing",
  READY = "ready",
  ERROR = "error",
}

export enum FileTypeEnum {
  IMAGE = "image",
  AUDIO = "audio",
  VIDEO = "video",
  DOCUMENT = "document",
  SVG = "svg",
}

export enum FileVisibilityEnum {
  PRIVATE = "private",
  PUBLIC = "public",
  INTERNAL = "internal",
}

export enum FileOriginEnum {
  UPLOAD = "upload",
  RECORDING = "recording",
  GENERATED = "generated",
  IMPORTED = "imported",
}

export enum ExerciseSessionStatusEnum {
  IN_PROGRESS = "in_progress",
  COMPLETED = "completed",
  ABORTED = "aborted",
  PARTIAL = "partial",
}

export enum ExerciseStepTypeEnum {
  INSTRUCTION = "instruction",
  INPUT_TEXT = "input_text",
  INPUT_CHOICE = "input_choice",
  INPUT_SCALE = "input_scale",
  MEDIA = "media",
  TIMER = "timer",
  SUMMARY = "summary",
}

export enum ExerciseSessionEventTypeEnum {
  CREATED = "created",
  RESUMED = "resumed",
  STEP_COMPLETED = "step_completed",
  STATUS_CHANGED = "status_changed",
  COMPLETED = "completed",
  ABORTED = "aborted",
  CORRECTION = "correction",
}

export enum BrainDomainEnum {
  EMOTIONAL = "emotional",
  COGNITIVE = "cognitive",
  BEHAVIORAL = "behavioral",
  PHYSIOLOGICAL = "physiological",
  SOCIAL = "social",
  COMPOSITE = "composite",
  META = "meta",
}

export enum BrainTimeHorizonEnum {
  MOMENTARY = "momentary",
  SHORT_TERM = "short_term",
  LONG_TERM = "long_term",
  VERY_LONG_TERM = "very_long_term",
  PERMANENT = "permanent",
}

export enum InteractionTargetTypeEnum {
  NEWS = "news",
  FAQ = "faq",
  EXERCISE = "exercise",
}

export enum InteractionTypeEnum {
  VIEW = "view",
  START = "start",
  COMPLETE = "complete",
  CLICK = "click",
  LIKE = "like",
  SAVE = "save",
  DISMISS = "dismiss",
}

export enum PresenceKeyScopeEnum {
  ADMIN = "admin",
  DEVICE = "device",
}

export enum DevicePlatformEnum {
  IOS = "ios",
  ANDROID = "android",
  WEB = "web",
}

export enum DeviceTypeEnum {
  PHONE = "phone",
  TABLET = "tablet",
  DESKTOP = "desktop",
  TV = "tv",
  UNKNOWN = "unknown",
}

export enum TextDirectionEnum {
  LTR = "ltr",
  RTL = "rtl",
}

export enum MeasurementSystemEnum {
  METRIC = "metric",
  US = "us",
  UK = "uk",
}

export enum TemperatureUnitEnum {
  CELSIUS = "celsius",
  FAHRENHEIT = "fahrenheit",
}

export enum CalendarIdentifierEnum {
  BUDDHIST = "buddhist",
  CHINESE = "chinese",
  COPTIC = "coptic",
  DANGI = "dangi",
  ETHIOAA = "ethioaa",
  ETHIOPIC = "ethiopic",
  GREGORY = "gregory",
  HEBREW = "hebrew",
  INDIAN = "indian",
  ISLAMIC = "islamic",
  ISLAMIC_CIVIL = "islamic-civil",
  ISLAMIC_RGSA = "islamic-rgsa",
  ISLAMIC_TBLA = "islamic-tbla",
  ISLAMIC_UMALQURA = "islamic-umalqura",
  ISO_8601 = "iso8601",
  JAPANESE = "japanese",
  PERSIAN = "persian",
  ROC = "roc",
}

export enum WeekdayEnum {
  SUNDAY = "sunday",
  MONDAY = "monday",
  TUESDAY = "tuesday",
  WEDNESDAY = "wednesday",
  THURSDAY = "thursday",
  FRIDAY = "friday",
  SATURDAY = "saturday",
}

export enum PushPermissionStatusEnum {
  GRANTED = "granted",
  DENIED = "denied",
  UNDETERMINED = "undetermined",
}

export enum AiModelCategoryEnum {
  EMBEDDING = "embedding",
  CHAT = "chat",
  SPEECH = "speech",
  TRANSCRIPTION = "transcription",
  IMAGE = "image",
  MUSIC = "music",
  SOUND = "sound",
}

export enum AiUsageSourceEnum {
  SYSTEM = "system",
  APP = "app",
}
